<template>
    <div class="board-list">
        <div class="tab-menu__wrap" @click.stop>
            <div class="tab-menu type01">
                <ul class="tab-menu__list">
                    <li class="tab-menu__item" v-for="cat in categoryList" :key="cat.value" :class="{ on: category === cat.value }">
                        <button type="button" class="tab-menu__btn" @click="selectCategory(cat)">{{ cat.label }}</button>
                    </li>
                </ul>
            </div>
        </div>

        <div class="contents" ref="pageContentEl" v-if="pageContent && pageContent.content" v-html="pageContent.content" @click.stop></div>

        <div class="board-gallery">
            <div class="contents board-gallery__list type2" @click.stop>
                <div class="item-wrap" v-for="(group, groupIndex) in galleryGroups" :key="groupIndex">
                    <div class="item-group">
                        <div class="board-gallery__item" v-for="(item, index) in group" :key="index" :class="{ show: activeCont === item.articleNo }" @click="showCont(item.articleNo, $event,item)">
                            <a href="javascript:;">
                                <img :src="`https://www.fatimahosp.co.kr//displayFile.do?name=${item.attachBag.thumbs[0].savedName}`" alt="이미지">
                                <div class="board-gallery__text">
                                    <h3>{{ item.title }}</h3>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="board-gallery__cont">
                        <div class="board-gallery__cont-inner">
                            <div v-html="this.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            boardInfo: ''
        },
        data() {
            return {
                board: {},
                list: [],
                activeCont: null,
                windowWidth: window.innerWidth,

                // 게시글 parameter
                currentNum: this.$route.query.currentNum || 1,
                pageRow: 999,
                content: '',

                // 카테고리 탭 (value는 CM_ARTICLE.category 값과 정확히 일치해야 함)
                category: '',

                // 게시판 상단 설명 콘텐츠(CM_CNTNT_DTL, menuNo로 조회)
                pageContent: '',
                customOrder: [18472,18473,15627,18474,18475,18476,18477,18478,15626,15624,15625,18479,15628,18480,15629,15623,15610,15609,15611,
                    15621,15617,15620,15615,15619,15612,18481,15614,15613,15616,15618,18482],
            }
        },
        watch: {
            $route(to, from) {
                // 동일 게시판 안에서 이동
                if (to.query != from.query && to.path == from.path) {
                    if (Object.keys(to.query).length === 0) this.init()
                    for (let i in this.$route.query) {
                        this[i] = this.$route.query[i]
                    }

                    this.getList()
                }
            },
            // 다른 게시판으로 이동
            boardInfo(oldVal, newVal) {
                this.init()
                this.getList()
            },
            category() {
                this.updateContentVisibility()
            }
        },
        computed: {
            // 선택된 카테고리로 필터링된 목록 (서버 재조회 없이 클라이언트에서 필터링)
            filteredList() {
                const list = Array.isArray(this.list) ? this.list : [];
                const categoryFiltered = this.category ? list.filter(item => item.category === this.category) : list;

                if (!this.customOrder.length) return categoryFiltered;

                const orderIndex = new Map(this.customOrder.map((no, idx) => [no, idx]));
                return [...categoryFiltered].sort((a, b) => {
                    const ai = orderIndex.has(a.articleNo) ? orderIndex.get(a.articleNo) : Infinity;
                    const bi = orderIndex.has(b.articleNo) ? orderIndex.get(b.articleNo) : Infinity;
                    if (ai !== bi) return ai - bi;
                    return a.articleNo - b.articleNo;
                });
            },
            galleryGroups() {
                const groups = [];
                const list = this.filteredList;

                if (list.length) {
                    const groupSize = this.windowWidth <= 720 ? 1 : 3;

                    for (let i = 0; i < list.length; i += groupSize) {
                        groups.push(list.slice(i, i + groupSize));
                    }
                }

                return groups;
            },
            // CM_BOARD의 category 값(콤마 구분 문자열)을 쪼개서 탭 목록 생성
            categoryList() {
                const raw = this.boardInfo && this.boardInfo.boardCategory ? this.boardInfo.boardCategory : ''
                const cats = raw.split(',').map(c => c.trim()).filter(Boolean)
                return [{ label: '전체', value: '' }, ...cats.map(c => ({ label: c, value: c }))]
            }
        },
        methods: {
            getList() {
                const boardNo = this.boardInfo.boardNo
                const params = {
                    instNo: 1,
                    boardNo: boardNo,
                    startIndex: this.currentNum,
                    pageRow: this.pageRow,
                }
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                })
                    .then(res => {
                        this.list = res.data.list || []
                        this.board = res.data.board || {}
                    })
                    .catch(() => {
                        this.list = []
                    })
            },
            // 카테고리 탭 선택 (서버 재조회 없이 이미 받아온 목록을 클라이언트에서 필터링)
            selectCategory(cat) {
                this.activeCont = null
                this.category = cat.value
            },
            // 게시판 상단 설명 콘텐츠(CM_CNTNT_DTL) 조회 - menuNo로 조회, 이 페이지 자신의 menuType은 'B'라서 'C' 조건은 제외
            getContent() {
                const path = this.$route.path
                let menuNo
                for (let i of this.menuList) {
                    if (i.menuUrl == path && i.useYn == 'Y') menuNo = i.menuNo
                }
                if (!menuNo) return

                this.axios.get(this.api.content.menuNo, {
                    params: { menuNo: menuNo }
                })
                    .then(res => {
                        this.pageContent = res.data
                        this.$nextTick(() => this.updateContentVisibility())
                    })
            },
            // pageContent 안의 카테고리별 div(id=카테고리값) 중 선택된 것만 표시, 전체(category === '')일 땐 전부 숨김
            updateContentVisibility() {
                const container = this.$refs.pageContentEl
                if (!container) return

                Array.from(container.children).forEach(el => {
                    if (!el.id) return
                    el.style.display = (this.category && el.id === this.category) ? 'block' : 'none'
                })
            },
            // 데이터 초기화
            init() {
                this.currentNum = 1
                this.content = ''
                this.category = ''
            },
            showCont(articleNo, event, item) {
                event.stopPropagation(); // 부모 엘리먼트로의 클릭 이벤트 전파를 막기 위해 stopPropagation() 사용
                if (this.activeCont === articleNo) {
                    this.activeCont = null;
                } else {
                    this.activeCont = articleNo;
                }
                this.content = item.content;
            },
            resetActiveCont() {
                this.activeCont = null;
            },
            updateWindowWidth() {
                this.windowWidth = window.innerWidth;
            }
        },
        mounted() {
            this.getList()
            this.getContent()
            document.addEventListener('click', this.resetActiveCont);
            window.addEventListener('resize', this.updateWindowWidth);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.resetActiveCont);
            window.removeEventListener('resize', this.updateWindowWidth);
        }
    }
</script>
<style>
.machine_box{border-radius: 10px;background-color: #ececf2;padding: 10px 15px;}
.board-gallery__list.type2 .item-group:has(.show)+.board-gallery__cont .board-gallery__cont-inner > div {display:flex; align-items:flex-start; gap:24px;}
.board-gallery__list.type2 .item-group:has(.show)+.board-gallery__cont .board-gallery__cont-inner > div .img_wrap {display:flex; flex-direction:column; gap:12px; width:30%;}

@media (max-width:1024px) {
    .board-gallery__list.type2 .item-group:has(.show)+.board-gallery__cont .board-gallery__cont-inner > div {flex-direction:column; gap:12px;}
    .board-gallery__list.type2 .item-group:has(.show)+.board-gallery__cont .board-gallery__cont-inner > div .img_wrap {flex-direction:row; gap:6px; justify-content: flex-start; width:100%;}
    .board-gallery__list.type2 .item-group:has(.show)+.board-gallery__cont .board-gallery__cont-inner > div .img_wrap > img {width:50%;}
}
</style>